const attributes = {
  name: 'nombre',
  email: 'email',
  password: 'contraseña',
  password_confirmation: 'confirmar contraseña',
}

export default attributes
